import axios from "axios";
import { API_BASE_URL } from "../../config/Config";

// <----------------- User Login ----------------------->
export const Global_Dashboard = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/dashboard`)
        return response
    } catch (error) {
        return error
    }
}

// <------------ Settings ------------------>
export const Global_Settings = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/settings`)
        return response
    } catch (error) {
        return error
    }
}

// <------------ home Page Api's --------------->
export const Get_Home_Page = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/web-home`)
        return response
    } catch (error) {
        return error
    }
}

// <------------Product list Api --------------------->
export const Get_Product_List = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/get-product`)
        return response
    } catch (error) {
        return error
    }
}
// <------------terms_conditions Api's --------------->
export const Get_Terms_Conditions = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/policy-data`)
        return response
    } catch (error) {
        return error
    }
}

// <------------terms_conditions Api's --------------->
export const Get_Privacy_Policy = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/privacy-policy`)
        return response
    } catch (error) {
        return error
    }
}

// <------------terms_conditions Api's --------------->
export const Get_return_policy = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/return-policy`)
        return response
    } catch (error) {
        return error
    }
}

// <------------terms_conditions Api's --------------->
export const Get_Faqs = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/faqs`)
        return response
    } catch (error) {
        return error
    }
}

// <------------terms_conditions Api's --------------->
export const Get_About_us = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/about-us`)
        return response
    } catch (error) {
        return error
    }
}
// <------------subhmuharats Api's --------------->
export const Get_Subhmuharats = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/subhmuharats`)
        return response
    } catch (error) {
        return error
    }
}

// <------------subhmuharats Api's --------------->
export const Get_Subhmuharats_Details = async (slug) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/subhmuharats`, {
            params: { slug },
        })
        return response
    } catch (error) {
        return error
    }
}

// <----------without Auth PoojaCategory ------------>
export const handle_fetch_master_data = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/master-data`)
        return response
    } catch (error) {
        return error
    }
}

// <---------get astrology page ------------>

export const Get_Astrology_pages = async (slug) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/get-astrology`,
        )
        return response
    } catch (error) {
        return error
    }
}
// <----------get astrology ------------>
export const Get_Astrology_data = async (slug) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/get-astrology`,
            {
                params: {
                    slug: slug
                }
            })
        return response
    } catch (error) {
        return error
    }
}
export const Get_Recommendation = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/get-Recommendation`)
        return response
    } catch (error) {
        return error
    }
}

export const Get_Custom_Designs = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/costom-design`)
        return response
    } catch (error) {
        return error
    }
}

// <-------- Get_Product_list ------------->
export const get_auth_limit_product = async ({ origin_id, shape_id, color_id, treatment_id, min_amount, max_amount }, headers) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/web-limit-product`, {
            params: {
                origin_id,
                shape_id,
                color_id,
                treatment_id,
                min_amount,
                max_amount
            }
            , headers: headers
        }
        );
        return response;
    } catch (error) {
        return error;
    }
};

export const get_limit_product = async ({ origin_id, shape_id, color_id, treatment_id, min_amount, max_amount, cut_id,
    certificate_id, composition_id }) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/limit-product`, {
            params: {
                origin_id,
                shape_id,
                color_id,
                treatment_id,
                min_amount,
                max_amount,
                cut_id,
                certificate_id,
                composition_id
            }
        });
        return response;
    } catch (error) {
        return error;
    }
};

// <-------- Product List ------------------->
export const get_limit_product_Details = async ({ id, category_id, subcategory_id }) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/limit-product`, {
            params: {
                id,
                category_id,
                subcategory_id
            }
        });
        return response;
    } catch (error) {
        return error;
    }
};
// curl --location --request POST 'https://rasatva.apponedemo.top/omens/api/get-best-product?subcat_id=3'
// <---------------Best selling products------------->
export const get_selling_products = async (subcategory_id) => {
    console.log("subcategory_id:", subcategory_id);
    try {
        const response = await axios.post(`${API_BASE_URL}/get-best-product?subcat_id=${subcategory_id}`, {
            params: {

                subcat_id: subcategory_id,
            }
        });
        return response;
    } catch (error) {
        return error;
    }
};

// <-------- Shop by collection ------------------->

export const get_shop_by_collection = async () => {

    try {
        const response = await axios.post(`${API_BASE_URL}/get-collection`);
        return response;
    } catch (error) {
        return error;
    }
};

// <-------- Shop by collection Product ------------------->


export const get_shop_by_collection_Product = async (slug) => {

    try {
        const response = await axios.post(`${API_BASE_URL}/get-collection?slug=${slug}`, {
            params: {
                slug: slug,
            }
        });
        return response;
    } catch (error) {
        return error;
    }
};


// <------------------ welcome note -----------> 

export const Get_Welcome_Note = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/welcome-note`);
        return response;
    } catch (error) {
        return error;
    }
};


export const send_recommendation = async (data) => {

    const [datePart, timePart] = data.dob.split('T');
    const fullDatetime = `${datePart} ${timePart}:00`;

    const formdata = {
        name: data?.name,
        email: data?.email,
        mobile: data?.phone,
        gender: data?.gender,
        purpose: data?.purpose,
        budget: data?.budget,
        birth_place: data?.placeOfBirth,
        dob: datePart,
        birth_time: fullDatetime
    }

    try {
        const response = await axios.post(`${API_BASE_URL}/recommendation`, formdata)
        return response;
    } catch (error) {
        return error;
    }
};


export const custom_jewellery = async (options) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/custom-detail`,
            options.body,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
        return response;
    } catch (error) {
        return error;
    }
};

export const Visitors = async (data) => {
    const bodydata = {
        ip: data?.ip,
        device: data?.device,
        page: data?.page,
        deviceId: data?.deviceId,
        browser: data?.browser
    }
    try {
        const response = await axios.post(`${API_BASE_URL}/store-visitor`,
            bodydata,
            {
                headers: {
                    "Content-Type": "application/json",
                    "referrer": data?.referrer
                },
            }
        );
        return response;
    } catch (error) {
        return error;
    }
};

export const send_Tour_Request = async (modalForm, headers) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/store-tour`, modalForm,
            { headers: headers }
        );
        return response;
    } catch (error) {
        return error;
    }
};

export const send_newsletter = async (formData) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/post-newsletter`, formData);
        return response;
    } catch (error) {
        return error;
    }
};

// <--------------get Each Page Seo--------->
export const get_Page_Seo = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/get-seo`);
        return response;
    } catch (error) {
        return error;
    }
};



export const Global_Searching = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/get-product`)
        return response
    } catch (error) {
        return error
    }
}
